module.exports = "/packs/003-dd5d813c3a22159f7c811eabaa76594a.jpg";